import { Component, OnInit, inject, input, model, output, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { TableModule } from 'primeng/table';
import { ProfileService } from '../../profile/services/profile.service';
import { ContractModel } from '../../shared/models/contract.model';
import { User } from '../../shared/models/user.model';
import { RoutesService } from '../../shared/services/routes.service';
import { ContractService } from '../services/contract.service';
import { CardModule } from 'primeng/card';
import { AccessModel } from '../../core/models/access.model';
import { AccessService } from '../../core/services/access.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-contract-list',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    ButtonGroupModule,
    CardModule,
  ],
  templateUrl: './contract-list.component.html',
  styleUrl: './contract-list.component.css'
})
export class ContractListComponent implements OnInit {
  service = inject(ContractService)
  accessService = inject(AccessService)
  profileService = inject(ProfileService)
  routesService = inject(RoutesService)

  resource = this.service.resource?.toLowerCase();

  detailed = input<boolean>(true);

  profile = signal<User | undefined>(undefined)
  access = signal<AccessModel | undefined>(undefined)

  value = this.service.contracts
  length = output<number>()

  ngOnInit(): void {
    this.service.title.update((value) => 'Lista de Contratos')
    this.access = this.accessService.access
    this.profile = this.profileService.getProfile()
    if (this.accessService.access()?.contract.actions.read) {
      this.service.get().subscribe(data => { this.value.update(value => {
        value = data as ContractModel[]
        this.length.emit(value.length)
        // console.log('Contract List: ', value)
        return value
      })})
    }
  }
}
